// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
// import NotificationPermissionDialog from './components/NotificationCenter/NotificationPermissionDialog';
// contexts
// import { NotificationProvider } from './contexts/NotificationContext';

// ----------------------------------------------------------------------

export default function App() {
	return (
		<ThemeConfig>
			{/* <NotificationProvider> */}
				<ScrollToTop />
				<GlobalStyles />
				<BaseOptionChartStyle />
				<Router />
				{/* <NotificationPermissionDialog /> */}
			{/* </NotificationProvider> */}
		</ThemeConfig>
	);
}
